import {Navigate, useLocation} from "react-router-dom";
import {RoutePaths} from "../../../../util/constants";
import {ReactElement} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../../store";

type Props = {
    showRoute: boolean;
    redirectTo?: RoutePaths;
    children: ReactElement;
};

export default function ProtectedRoute({
                                           showRoute,
                                           redirectTo = RoutePaths.HOME,
                                           children,
                                       }: Props) {
    const location = useLocation();
    const appLoading = useSelector((state: RootState) => state.appReducer.appLoading)

    // Extract ?redirect=... if present
    const params = new URLSearchParams(location.search);
    const redirectParam = params.get("redirect");

    const finalRedirect = redirectParam || redirectTo;

    return showRoute || appLoading ? children : <Navigate to={finalRedirect} replace/>;
}
